import { render, staticRenderFns } from "./host-set-Exnews.vue?vue&type=template&id=544a4bf0&scoped=true&"
import script from "./host-set-Exnews.vue?vue&type=script&lang=js&"
export * from "./host-set-Exnews.vue?vue&type=script&lang=js&"
import style0 from "./host-set-Exnews.vue?vue&type=style&index=0&id=544a4bf0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544a4bf0",
  null
  
)

export default component.exports